import React, { useState, useEffect } from 'react';
import Notes from './Notes';
import getEventColor from '../utils/eventColors';
import { checkNotes } from '../utils/api';
import { formatTime } from '../utils/dateUtil';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faCheck } from '@fortawesome/free-solid-svg-icons';

const Event = ({ event }) => {
  const [notesCompleted, setNotesCompleted] = useState(false);
  const [showNotes, setShowNotes] = useState(false);
  const { id, name, start_at, end_at, staff_members, people } = event;
  const staffMember = localStorage.getItem('user');

  useEffect(() => {
    checkNotes(id)
      .then((data) => {
        if (data.notes.length === 0) {
          setNotesCompleted(false);
          return;
        }
        console.log(data);
        for (let i = 0; i < data.notes.length; i++) {
          if (data.notes[i].created_by_id !== 7402305) {
            setNotesCompleted(true);
            break;
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id, notesCompleted]);

  const appendToString = (s) => (s === staffMember ? s + ' (You)' : s);

  const staffMembersString =
    staff_members.length > 2
      ? staff_members
          .slice(0, 2)
          .map((staff) => appendToString(staff.name))
          .join(', ') + ` +${staff_members.length - 2}`
      : staff_members.map((staff) => appendToString(staff.name)).join(', ');

  const attendeesString =
    people.length > 2
      ? people
          .slice(0, 2)
          .map((person) => person.name)
          .join(', ') + ` +${people.length - 2}`
      : people.map((person) => person.name).join(', ');

  const nameString = name.length > 30 ? name.slice(0, 25) + '...' : name;
  const icon = staff_members.some((staff) => staff.name === staffMember) ? (
    <FontAwesomeIcon icon={faStar} />
  ) : null;
  const check = notesCompleted ? <FontAwesomeIcon icon={faCheck} /> : null;

  return (
    <div
      className={`p-4 border-t-8 transition duration-300
                bg-zinc-100 text-zinc-900 dark:bg-zinc-900 dark:text-zinc-100
                  shadow-lg shadow-zinc-600 dark:shadow-zinc-950
                  cursor-pointer ${getEventColor(name,showNotes)}
                  ${showNotes ? 'sm:col-span-2 h-full sm:hover:border-zinc-900 sm:dark:hover:border-zinc-100 duration-500' : 'h-max sm:hover:-translate-y-2 sm:hover:scale-105'}
                  `}
      onClick={() => setShowNotes(!showNotes)}
    >
      <h3 className={`${!showNotes && 'truncate'} text-md font-bold`}>{icon} {people.length > 0 ? attendeesString : nameString}</h3>
      <h3 className={`${!showNotes && 'truncate'} text-md font-bold`}>{formatTime(start_at)} to {formatTime(end_at)}</h3>
      <h4 className={`text-sm font-semibold ${!showNotes && 'truncate'}`}>
        {name} with {staff_members.length > 0 ? staffMembersString : 'None'}
      </h4>
      {showNotes && (
        <Notes
          eventId={id}
          closeNote={(e) => {
            e.stopPropagation();
            setShowNotes(false);
          }}
          people={people}
          staffMember={staffMember}
        />
      )}
    </div>
  );
};

export default Event;
